import { TraitTypeNumeric } from './TraitTypeNumeric';
export class TraitTypeNumericWithSlider extends TraitTypeNumeric {
}
